import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../shared/service/api.service';
import { GlobalService } from '../../shared/service/global.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styles: [
  ]
})
export class PrivacyComponent implements OnInit {

  dataBanner;
  dataSection;
  dataLink;
  isLang;

  constructor(public globalService : GlobalService,
              private router: Router,
              private apiService: ApiService){ 
    this.globalService.isLoading.next(true);
  }


  ngOnInit(): void {
    //MultiLanguage
    this.apiService.lang.subscribe(response => {
      this.isLang = response;
    });

    this.dataLink = this.router.url.split("/", 2)[1];
    this.globalService.isLoading.next(true);
    
    //contents
    this.apiService.getDataApi('getMenuSection/'+this.dataLink).subscribe(response => {
      if(response.success){
        this.dataBanner = response.data;
        this.dataSection = response.data.section[0];
        //Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      }else{
        this.router.navigate(['/not-found']);
      }
    }); 
  }

}
